import { useMutation } from 'react-query';
import { useTranslation } from 'react-i18next';
import {CORE_API_SUFFIX, dataFetch, DIGGER_API_SUFFIX} from '../../../axios/customAxios';
import { handleApiError } from '../../requestHelpers/requestHelpers';
import { ApiError, ApiResponse } from '../../../interfaces/apiResponse.type';
import closableEnqueueSnackbar from '../../../components/closableEnqueueSnackbar/closableEnqueueSnackbar';
import { useOrganizationSettingsStore } from '../../../store/organizationSettingsStore';

export const useSendDisconnectFacebookConversion = () => {
    const { t } = useTranslation();
    const { organizationSettings, setOrganizationSettings } = useOrganizationSettingsStore();

    return useMutation<ApiResponse<null>, ApiError<null>>(
        () => dataFetch.patch(
            `${CORE_API_SUFFIX}organization-settings/facebook-conversion/uninstall`,
        ),
        {
            onSuccess: () => {
                closableEnqueueSnackbar(t('disconnectedSuccess'), 'success');
                setOrganizationSettings({ ...organizationSettings, isConnectedToFacebookConversionApi: false });
            },
            onError: (error: any) => {
                handleApiError(error, t);
            },
        },
    );
};

export const useSendFacebookAccessToken = () => {
    const { t } = useTranslation();

    return useMutation<ApiResponse<null>, ApiError<null>, any>(
        (token: any) => dataFetch.patch(
            `${CORE_API_SUFFIX}organization-settings`,
            {
                facebookConversionApiToken: token.tokenId,
                facebookPixelId : token.pixelId,
            }
        ),
        {
            onSuccess: () => {
                closableEnqueueSnackbar(t('metaCapiTokenSaved'), 'success');
            },
            onError: (error: any) => {
                handleApiError(error, t);
            },
        },
    );
};
